<div class="overlay" *ngIf="isLoading | async">
  <div class="spinner">
    <div class="spinner-part spinner-part1"></div>
    <div class="spinner-part spinner-part2"></div>
    <img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
  </div>
</div>
<div class="container-fluid pl-0">
  <div class="container-inner">
    <div [hidden]="isCreate || isEdit">
      <div class="header-container">
        <h2>Document Upload</h2>
        <div class="search-container mb-1">
          <input type="text" [formControl]="searchInput" placeholder="Search..." (input)="applyFilter()"
            class="form-control" />
          <span class="clear-icon" *ngIf="searchInput.value" (click)="clearSearch()">&times;</span>
        </div>
        <div class="button-container">
          <button mat-raised-button class="add-button" (click)="add()">Upload Documents</button>
        </div>
      </div>
      <div class="leads-table mb-3">
        <table mat-table [dataSource]="dataSource" matSort class="mat-table">
          <ng-container matColumnDef="SNo">
            <th mat-header-cell *matHeaderCellDef> S.No </th>
            <td mat-cell *matCellDef="let element; let i = index"> {{ (paginatorRef.pageIndex *
              paginatorRef.pageSize) + (i + 1) }}</td>
          </ng-container>

          <ng-container matColumnDef="product_category">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Product category</th>
            <td mat-cell *matCellDef="let element">{{element?.product_category}}</td>
          </ng-container>

          <ng-container matColumnDef="product_model">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Model</th>
            <td mat-cell *matCellDef="let element">{{element?.product_model}} - {{element?.product_model_code}}</td>
          </ng-container>

          <ng-container matColumnDef="documents">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>No of Documents</th>
            <td mat-cell *matCellDef="let element">{{element.product_document_data.length}}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let element; let j = index">
              <div class="form-check form-switch" title="Change to {{element.status ? 'In-Active' : 'Active'}}">
                <input class="form-check-input" type="checkbox" [checked]="element.status" id="{{j+1}}"
                  (click)="changeStatus($event.target, element)">
              </div>
            </td>
          </ng-container>

          <!-- Action Column -->
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef style="text-align: center;">Action</th>
            <td mat-cell *matCellDef="let element" style="text-align: center;">
              <img [src]="bucketurl + '/images/pen.png'" class="edit-pen" title="Edit" (click)="editData(element)">
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" style="text-align: center;padding: 20px 0;" colspan="4">No data found!
            </td>
          </tr>
        </table>

        <mat-paginator #paginatorRef [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
      </div>
    </div>
    <ng-container *ngIf="isCreate || isEdit">
      <div class="header-container">
        <h2>Document Upload</h2>
        <div class="button-container">
          <button mat-raised-button class="add-button" (click)="back()">Back to List</button>
        </div>
      </div>
      <form [formGroup]="documentUploadForm">
        <div class="row">
          <div class="row">
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Product Category</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <select name="" class="form-select" formControlName="category" (change)="onCategoryChange()"
                  [attr.value]="documentUploadForm.get('category')?.value"
                  [ngClass]="{ 'is-invalid': submitted && f['category'].errors }">
                  <option value="" disabled selected>--Select Product Category--</option>
                  <option [value]="data.id" *ngFor="let data of categoryList">{{data.product_category}}</option>
                </select>
                <div *ngIf="submitted && f['category'].errors" class="invalid-feedback">
                  <div *ngIf="f['category'].errors['required']">Product Category is required</div>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Product Model</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <select name="" class="form-select" formControlName="model"
                  [attr.value]="documentUploadForm.get('model')?.value"
                  [ngClass]="{ 'is-invalid': submitted && f['model'].errors }">
                  <option value="" disabled selected>--Select Product Model--</option>
                  <option [value]="data.id" *ngFor="let data of modelList">{{data.model}} - {{data.model_code}}</option>
                </select>
                <div *ngIf="submitted && f['model'].errors" class="invalid-feedback">
                  <div *ngIf="f['model'].errors['required']">Product Model is required</div>
                </div>
              </div>
            </div>



            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>File Type</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <select name="" class="form-select" formControlName="type"
                  [attr.value]="documentUploadForm.get('type')?.value"
                  [ngClass]="{ 'is-invalid': submitted && f['type'].errors }" (change)="onTypeChange()">
                  <option value="" disabled selected>--Select File Type--</option>
                  <option [value]="data.id" *ngFor="let data of fileTypes">{{data.file_type}}</option>
                </select>
                <div *ngIf="submitted && f['type'].errors" class="invalid-feedback">
                  <div *ngIf="f['type'].errors['required']">File type is required</div>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2" *ngIf="isLink">
              <div class="themeinput">
                <label>Link</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <input type="text" class="form-control" id="link" placeholder="Link" formControlName="link"
                  [attr.value]="documentUploadForm.get('link')?.value"
                  [ngClass]="{ 'is-invalid': submitted && f['link'].errors }">
                <div *ngIf="submitted && f['link'].errors" class="invalid-feedback">
                  <div *ngIf="f['link'].errors['required']">Link is required</div>
                  <div *ngIf="f['link'].errors['pattern']">Link is invalid</div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2" *ngIf="isLink">
              <div class="themeinput">
                <label>Name For Link</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <input type="text" class="form-control" [(ngModel)]="linkName" [ngModelOptions]="{standalone: true}"
                  placeholder="Name For Link">
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2" *ngIf="isDocument">
              <div class="themeinput">
                <label>Document</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <div class="custom-file-upload">
                  <input type="file" id="fileInput" #fileInput (click)="fileInput.value = ''" multiple
                    (change)="onFileChange($event)" />
                  <label for="fileInput">Choose File</label>
                  <div>
                    <span style="color: grey;font-size: 11px;">Note: Max file size is 10 MB</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-6 mt-2">
            <ul class="list-group">
              <label *ngIf="uploadedFiles.length > 0 || alreadyUploadedFiles.length > 0">Uploaded Files List</label>
              <ng-container *ngIf="isEdit && alreadyUploadedFiles.length >0">
                <li *ngFor="let file of alreadyUploadedFiles; let i = index"
                  class="list-group-item d-flex justify-content-between align-items-center">
                  <ng-container *ngIf="file?.document_file_type?.is_document == 1">
                    <span class="file-text" title="{{file.file_name}}"> {{ file?.file_name }}</span>
                    <span class="file-size"> {{ file?.file_size ? file?.file_size : '' }}</span>
                    <a class="" href="{{file.document}}" download title="Download">
                      <img style="width: 25px;cursor: pointer;" src="/assets/images/file.png" alt="">
                    </a>
                    <div class="form-check form-switch" title="Change to {{file.status ? 'In-Active' : 'Active'}}">
                      <input class="form-check-input" type="checkbox" [checked]="file.status" id="{{i+1}}"
                        (click)="updateStatus($event.target, file)">
                    </div>
                  </ng-container>
                  <ng-container *ngIf="file?.document_file_type?.is_document == 0">
                    <a [href]="file.document" target="_blank" title="Open Link" class="text-primary"
                      style="font-size: 12px;">
                      {{ file.document_name || file.document }}
                    </a>
                    <div class="flex" style="width: 27%; display: flex; justify-content: space-between;">
                    <a class="" href="{{file.document}}" target="_blank" title="Open Link">
                      <img style="width: 25px;cursor: pointer;" src="/assets/images/external.png" alt="">
                    </a>
                    <div class="form-check form-switch" title="Change to {{file.status ? 'In-Active' : 'Active'}}">
                      <input class="form-check-input" type="checkbox" [checked]="file.status" id="{{i+1}}"
                        (click)="updateStatus($event.target, file)">
                    </div>
                    </div>
                  </ng-container>
                  <!-- <button type="button" class="btn btn-danger btn-sm" (click)="removeFile(i)">Remove</button> -->
                </li>
              </ng-container>

              <li *ngFor="let file of uploadedFiles; let i = index"
                class="list-group-item d-flex justify-content-between align-items-center">
                <span class="file-text" title="{{file.name}}"> {{ file.name }}</span>
                <span class="file-size"> {{ formatFileSize(file.size) }}</span>
                <img style="width: 25px;cursor: pointer;" src="/assets/images/trash.png" alt="" title="Delete"
                  (click)="removeFile(i)">
              </li>
            </ul>
          </div>

          <div class="col-lg-12 mt-5">
            <div class="text-right-right">
              <button *ngIf="isCreate" mat-raised-button class="clear-button" (click)="clearForm()">Clear</button>
              <button mat-raised-button class="create-button ml-2" (click)="create()">Upload</button>
            </div>
          </div>
        </div>
      </form>
    </ng-container>
  </div>
</div>